<template>
  <div>
    <b-container class="wide">
      <head-block :title="$t('title.customer.finalize_booking_payment_request')" />
        <booking-checkout-component
          v-if="!paymentSuccessful && bookingRequest && Array.isArray(bookingRequest.eligibleClosingDays) && bookingRequest.shelfTypeName"
          :market="market"
          :bookingsInfo="[bookingRequest]"
          :isCustomerBooking="isCustomerView"
          :customerEmail="selectedBookingRequest.customerEmail"
          @paymentSuccessful="confirmPayment"
          @backToBookingCalendar="goToBookingRequests"
          :isBookingPaymentRequest="true"
        />
      <div class="mt-5 text-secondary" v-else-if="paymentSuccessful">
        <h3 class="text-center">{{ $t('notifications.text.create_booking.success_booking_confirmed') }}. {{ $t('notifications.text.create_booking.success_countdown_redirection', { countDown: countDown }) }}</h3>
      </div>
    </b-container>
  </div>
</template>

<script>

  import { mapState } from 'vuex'
  import countDownTimerMixin from "@base/mixins/CountDownTimerMixin.vue";
  import { REDIRECT_COUNTDOWN_SECONDS } from "@base/configs";
  import BookingCheckoutComponent from "@base/components/booking/BookingCheckoutComponent.vue";
  import BookingPeriodLabelMixin from "@base/mixins/BookingPeriodLabelMixin.vue";
  import HeadBlock from "@base/components/HeadBlock.vue";
  import moment from "moment";

  export default {
    name: 'BookingPaymentRequestView',
    components: {
      HeadBlock,
      BookingCheckoutComponent },

    mixins: [countDownTimerMixin, BookingPeriodLabelMixin],

    data () {
      return {
        loading: false,
        paymentSuccessful: false,
        countDown: REDIRECT_COUNTDOWN_SECONDS,
        bookingRequest: null,
      }
    },

    props: {
      isCustomerView: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapState({
      selectedBookingRequest: state => state.selectedBookingRequest,
      market () {
        return this.isCustomerView
          ? this.$store.state.userMarket
          : this.$store.state.anonMarket
        }
      }),
    },

    created () {
      if (this.market) {
        this.constructBookingInfo()
      }
    },

    watch: {
      'market' () {
        this.constructBookingInfo()
      }
    },

    methods: {
      goToBookingRequests () {
        this.isCustomerView ? this.$router.push({name: 'bookings'}) : this.$router.push({name: 'user-login', params: { marketId: this.market.marketId }})
      },

      confirmPayment () {
        this.paymentSuccessful = true
        this.countDownTimer(this.countDown, this, { name: 'bookings' })
      },

      constructBookingInfo () {
        const startDate = moment(this.selectedBookingRequest.dateStart)
        const endDate = moment(this.selectedBookingRequest.dateEnd)
        const dateRange = [startDate];
        this.bookingRequest = this.$_.cloneDeep(this.selectedBookingRequest)
        const eligibleClosingDays = []

        while (startDate.date() !== endDate.date()) {
          startDate.add(1, 'days');
          dateRange.push(startDate.format('YYYY-MM-DD'));
        }
        for (let specialClosingDate of this.market.closingDays) {
          // We have a closing day during booking period - add one more day to period
          if (dateRange.includes(specialClosingDate)) {
            eligibleClosingDays.push(specialClosingDate)
          }
        }
        this.bookingRequest['eligibleClosingDays'] = eligibleClosingDays
        this.bookingRequest['shelfTypeName'] = this.selectedBookingRequest.shelfType.name
        this.bookingRequest['bookingPeriodLabel'] = this.selectedBookingRequest.shelfPeriodPrice ? this.bookingPeriodLabel(this.selectedBookingRequest.shelfPeriodPrice.bookingPeriod, false) : this.$t('table.booking_periods.custom_period_label')
        this.bookingRequest['bookingRequest'] = this.selectedBookingRequest.id
        localStorage.setItem('paymentRequestCartToken', this.selectedBookingRequest.cartToken)
      }
    }
  }
</script>

<style scoped>

</style>